export default __webpack_public_path__ + "static/banner-f81af50b250bf969353f3dc3867409a5.png";